import history from './history'
import config from '../../proxyConfig/index'
import * as Sentry from '@sentry/react'
import { isProductionLikeEnvironment } from './runtime-environment'

const sentryInit = () => {
  if (!isProductionLikeEnvironment) {
    return null
  }

  if (Sentry) {
    const { VITE_REACT_APP_VERSION, VITE_TARGET_ENV, VITE_SENTRY_DSN } =
      import.meta.env

    const escapeRegExp = (string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }

    const release = `${VITE_REACT_APP_VERSION || '00'}${
      !!VITE_TARGET_ENV && VITE_TARGET_ENV !== 'production'
        ? VITE_TARGET_ENV.substring(0, 2)
        : ''
    }`

    const baseUrlRegexPattern = `^${escapeRegExp(config.url)}`

    const baseUrlRegex = new RegExp(baseUrlRegexPattern)

    Sentry.init({
      dsn: VITE_SENTRY_DSN,
      environment: VITE_TARGET_ENV,
      debug: VITE_TARGET_ENV !== 'production',
      release,
      attachStacktrace: true,
      replaysSessionSampleRate: 0.02,
      replaysOnErrorSampleRate: 0.5,
      tracesSampleRate: 0.01,
      tracePropagationTargets: ['localhost', baseUrlRegex],
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: true,
          networkDetailAllowUrls: ['https://traefik.cloud.docu.solutions/'],
          networkRequestHeaders: ['X-Custom-Header'],
          networkResponseHeaders: ['X-Custom-Header']
        }),
        Sentry.reactRouterV5BrowserTracingIntegration({ history })
      ]
    })
  }
}

export default sentryInit
